import { Component, ViewChild, ElementRef, AfterViewInit, OnInit, NgZone } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AuthenticatorComponent } from '../tools/authenticator/authenticator.component';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { PhoneAuthComponent } from '../pages/phone-auth/phone-auth.component';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { VirtualauthenticatorComponent } from '../tools/virtualauthenticator/virtualauthenticator.component';



@Component({
  selector: 'app-home-component2',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    CommonModule
  ],
  templateUrl: './home-component2.component.html',
  styleUrls: ['./home-component2.component.css']
})


export class HomeComponent2Component implements AfterViewInit, OnInit {
  constructor(private loginSheet: MatBottomSheet, private router: Router, private authService: AuthService, private ngZone: NgZone) { }

  isPlaying: boolean = false;
  isOnline: boolean = navigator.onLine;
  private audio: HTMLAudioElement | null = null;
  private shouldPlayAudio: boolean = true;

  @ViewChild('audioPlayer') set audioPlayer(element: ElementRef<HTMLAudioElement>) {
    if (element) {
      this.audio = element.nativeElement;
      this.setupAudioListeners();
      if (this.shouldPlayAudio) {
        setTimeout(() => {
          this.forcePlayAudio();
        }, 0);
      }
    }
  }

  ngOnInit(): void {
    window.addEventListener('online', () => this.isOnline = true);
    window.addEventListener('offline', () => this.isOnline = false);
    
    if(this.authService.isAuthenticated()) {
      this.router.navigate(['postfeed']);
    }
  }

  ngAfterViewInit() {
    // Configuration gérée par le setter
  }

  private setupAudioListeners() {
    if (!this.audio) return;

    this.audio.addEventListener('playing', () => {
      this.ngZone.run(() => {
        this.isPlaying = true;
        console.log('Audio en lecture');
      });
    });
    
    this.audio.addEventListener('pause', () => {
      this.ngZone.run(() => {
        this.isPlaying = false;
        console.log('Audio en pause');
      });
    });
    
    this.audio.addEventListener('ended', () => {
      this.ngZone.run(() => {
        this.isPlaying = false;
        console.log('Audio terminé');
      });
    });

    this.audio.addEventListener('canplay', () => {
      console.log('Audio peut être lu');
      if (this.shouldPlayAudio) {
        this.forcePlayAudio();
      }
    });
  }

  private forcePlayAudio() {
    if (!this.audio || !this.shouldPlayAudio) return;

    const playPromise = this.audio.play();
    if (playPromise !== undefined) {
      playPromise.then(() => {
        this.ngZone.run(() => {
          this.isPlaying = true;
          console.log('Lecture démarrée avec succès');
        });
      }).catch(error => {
        console.error('Erreur de lecture:', error);
      });
    }
  }

  stopAudio() {
    if (this.audio) {
      this.shouldPlayAudio = false;  // Empêcher toute future lecture automatique
      this.audio.pause();
      this.audio.currentTime = 0;
      this.isPlaying = false;
      // Supprimer les écouteurs d'événements pour éviter toute reprise
      this.audio.removeEventListener('canplay', this.forcePlayAudio);
    }
  }

  toggleAudio() {
    if (!this.audio) {
      console.error('Élément audio non disponible');
      return;
    }

    if (this.audio.paused) {
      this.shouldPlayAudio = true;  // Réactiver la lecture uniquement lors d'un clic manuel
      this.forcePlayAudio();
    } else {
      this.audio.pause();
    }
  }

  onGetStartedClick(){
    this.stopAudio(); // Arrêter l'audio
    this.loginSheet.open(AuthenticatorComponent, {
      panelClass: 'custom-bottom-sheet'
    });
  }
  
  onGetStartedClick2() {
    this.stopAudio(); // Arrêter l'audio
    this.loginSheet.open(PhoneAuthComponent, {
      panelClass: 'custom-bottom-sheet',
      data: { showPhoneLogin: true }
    });
  }

  onGetStartedClick3() {
    this.stopAudio(); // Arrêter l'audio
    this.loginSheet.open(VirtualauthenticatorComponent, {
      panelClass: 'custom-bottom-sheet',
      data: { showAnonymousLogin: true }
    });
  }

  /*loginAnonymously() {
    this.authService.loginAnonymously();
  } */
}
